import { Authcontext } from "../Context/AuthContext"
import { useContext } from "react"
import Cart from "./Cart"
import Signup from "./SignUp"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import SignIn from "./SignIn"

function PrivetRoute({props}){
  const isAuth=useSelector((store)=>store.authReducer.isAuth)

    
   return isAuth? <Cart/>:<SignIn/>
}
export default PrivetRoute